"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../../Theme/constant");
var _default = {
  PropTypes: {
    onClickSearch: _propTypes.func,
    placeholder: _propTypes.string,
    errorMessage: _propTypes.string,
    initialValue: _propTypes.string,
    theme: _propTypes.string,
    accessible: _propTypes.bool,
    translation: (0, _propTypes.shape)({
      search: _propTypes.string,
      invalidEmailMessage: _propTypes.string,
      detailedInvalidEmailMessage: _propTypes.string
    }),
    newVersion: _propTypes.bool,
    disabled: _propTypes.bool
  },
  DefaultProps: {
    accessible: true,
    theme: _constant.DEFAULT_THEME,
    onClickSearch: function onClickSearch() {},
    placeholder: 'Email address (optional)',
    initialValue: '',
    translation: {
      search: 'Search',
      invalidEmailMessage: 'That’s an invalid email format',
      detailedInvalidEmailMessage: 'Please enter a valid email (example@email.com)',
      noData: 'We are unable to fetch any details now. Try again later in manage booking'
    },
    newVersion: false,
    disabled: false
  }
};
exports.default = _default;